<template>
  <div>
    <div class="container pt-4">
      <ul class="stepper stepper--warning">
        <li v-for="i in 5" :key="i">
          <span class="stepper__count" :class="{ active: i <= step }">
            {{ i }}
          </span>
        </li>
      </ul>
    </div>
    <div class="container my-5">
      <div class="lead text-center mb-3">#UNILABS: Servicio a Domicilio</div>
      <div class="row justify-content-center">
        <div v-if="isStep(0)" class="col-12 py-4 text-center">
          <i class="fa fa-spin fa-spinner fa-2x"></i>
        </div>
        <div v-if="isStep(1)" class="col-md-10 col-lg-7">
          <div class="card bg-light">
            <div class="p-3 p-sm-4">
              <h5 class="mb-3">
                <router-link to="/" class="text-decoration-none">
                  <i class="fa fa-arrow-left"></i>
                </router-link>
                <span class="stepper__count ml-3 mr-1 small">
                  <b>1</b>
                </span>
                Selecciona el día para la cita
              </h5>
              <p>
                En el siguiente calendario puedes seleccionar el día que quieres reservar tu cita.
              </p>
              <div class="mb-4">
                <v-date-picker
                  v-model="selectedDate"
                  :available-dates="availableDates"
                  :attributes="attributes"
                  :from-date="selectedDate || availableDates[0].start"
                  :masks="{ weekdays: 'WWW' }"
                  color="red"
                  is-inline
                  is-expanded
                  @input="selectDate($event)"
                />
              </div>
              <div class="text-right">
                <button
                  type="button"
                  class="btn btn-warning rounded-50"
                  :disabled="!selectedDate"
                  @click="step = 2"
                >
                  Guardar y continuar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isStep(2)" class="col-md-10 col-lg-7">
          <div class="card bg-light">
            <div class="p-3 p-sm-4">
              <h5 class="mb-3">
                <a href="#" class="text-decoration-none" @click.prevent="step = 1">
                  <i class="fa fa-arrow-left"></i>
                </a>
                <span class="stepper__count ml-3 mr-1 small">
                  <b>2</b>
                </span>
                Selecciona el horario de tu cita
              </h5>
              <p>Aquí debes de ingresar el horario de la cita.</p>
              <div class="my-5 text-center">
                <div class="form-row">
                  <div v-for="hour in dateSelect.hours" :key="hour.timeId" class="col-sm-6 mb-2">
                    <button
                      type="button"
                      class="btn btn-block"
                      :class="`${
                        dateHourSelect && dateHourSelect.timeId === hour.timeId
                          ? 'btn-primary'
                          : 'btn-outline-primary'
                      }`"
                      :disabled="!hour.stock"
                      @click="selectDateHour(hour)"
                    >
                      <div>
                        <span v-if="twoSchedules">
                          {{ getSchedule(hour) }}
                        </span>
                        <span v-else>
                          {{ parseHourString(hour.timeStart) }}
                        </span>
                      </div>
                      <small>({{ hour.qtyStock }} disponibles)</small>
                    </button>
                  </div>
                </div>
              </div>
              <div class="text-right">
                <button
                  type="button"
                  class="btn btn-warning rounded-50"
                  :disabled="!dateHourSelect"
                  @click="step = 3"
                >
                  Guardar y continuar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isStep(3)" class="col-md-10 col-lg-7">
          <div class="card bg-light">
            <form class="p-3 p-sm-4" @submit.prevent="validateDataUser()">
              <h5 class="mb-3">
                <a href="#" class="text-decoration-none" @click.prevent="step = 2">
                  <i class="fa fa-arrow-left"></i>
                </a>
                <span class="stepper__count ml-3 mr-1 small">
                  <b>3</b>
                </span>
                Información del comprador
              </h5>
              <p>Aquí debes de ingresar la información del comprador de las pruebas.</p>
              <div class="my-4">
                <div class="card">
                  <div class="p-3">
                    <h6 class="text-action">
                      <b>Datos del comprador</b>
                    </h6>
                    <p>Completa los datos del comprador</p>
                    <div class="form-row">
                      <div class="col-12 col-sm-6">
                        <div class="form-group">
                          <label for="doctype" class="mb-1">Tipo documento</label>
                          <select v-model="user.documentType" id="doctype" class="form-control">
                            <option v-for="i in docTypes" :key="i" :value="i">
                              {{ i }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-12 col-sm-6">
                        <div class="form-group">
                          <label for="docNumber" class="mb-1">N° Documento</label>
                          <input
                            v-model="user.document"
                            id="docNumber"
                            class="form-control"
                            type="tel"
                            placeholder="DNI"
                            required
                            :minlength="user.documentType === 'DNI' ? 8 : 6"
                            :maxlength="user.documentType === 'DNI' ? 8 : 15"
                            pattern="[a-zA-Z0-9]+"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label for="name" class="mb-1">Nombres</label>
                          <input
                            v-model.trim="user.name"
                            id="name"
                            class="form-control"
                            type="text"
                            placeholder="nombres completos"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-12 col-md-6">
                        <div class="form-group">
                          <label for="lastname" class="mb-1">Apellidos</label>
                          <input
                            v-model.trim="user.lastName"
                            id="lastname"
                            type="text"
                            class="form-control"
                            placeholder="apellidos completos"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group">
                          <label for="email" class="mb-1">Correo</label>
                          <input
                            v-model.trim="user.email"
                            id="email"
                            type="email"
                            class="form-control"
                            placeholder="Correo electrónico"
                            required
                          />
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group">
                          <label for="phone" class="mb-1">N° Teléfono/Celular</label>
                          <input
                            v-model="user.phone"
                            id="phone"
                            type="number"
                            class="form-control"
                            placeholder="Teléfono"
                            required
                            minlength="6"
                            maxlength="15"
                          />
                        </div>
                      </div>
                      <div v-if="error" class="col-12 mb-3">
                        <div class="is-small has-text-danger">
                          {{ error }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-right">
                <button type="submit" class="btn btn-warning rounded-50" :disabled="loading">
                  <i v-if="loading" class="fa fa-spin fa-spinner mr-2"></i>
                  Guardar y continuar
                </button>
              </div>
            </form>
          </div>
        </div>
        <div v-if="isStep(4)" class="col-lg-12">
          <div class="card bg-light">
            <form class="p-3 p-sm-4" @submit.prevent="nextInvoice()">
              <h5 class="mb-3">
                <a href="#" class="text-decoration-none" @click.prevent="step = 3">
                  <i class="fa fa-arrow-left"></i>
                </a>
                <span class="stepper__count ml-3 mr-1 small">
                  <b>4</b>
                </span>
                Información de los pacientes
              </h5>
              <p>
                Aquí debes de ingresar la información de los pacientes que realizarán las pruebas.
              </p>
              <div class="my-4">
                <div v-for="(item, idx) in participants" :key="idx" class="card bg-light mb-4">
                  <div class="p-3">
                    <div class="row">
                      <div class="col">
                        <h6 class="text-action">
                          <b>Paciente N° {{ idx + 1 }}</b>
                        </h6>
                      </div>
                      <div class="col-auto">
                        <a
                          v-if="idx > 0"
                          href="#"
                          class="text-muted"
                          @click.prevent="trashParticipant(idx)"
                        >
                          <i class="fa fa-trash mr-1"></i>
                          Eliminar
                        </a>
                      </div>
                    </div>
                    <p>
                      Completa todos los datos del paciente e ingresa el tipo de prueba y la
                      dirección del paciente
                    </p>
                    <div class="row">
                      <div class="col-lg-6">
                        <div v-if="idx === 0" class="card py-2 px-3 mb-3">
                          <b-form-checkbox v-model="autoCompleteP" name="check-button" switch>
                            <b>Completar con datos del comprador</b>
                          </b-form-checkbox>
                        </div>
                        <div class="row">
                          <div class="col-6">
                            <div class="form-group">
                              <label :for="`pDoct-${idx}`" class="mb-1">Tipo de documento</label>
                              <div>
                                <select
                                  v-model="item.documentType"
                                  :id="`pDoct-${idx}`"
                                  class="form-control form-control-sm"
                                >
                                  <option v-for="i in docTypes" :key="i" :value="i">
                                    {{ i }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group">
                              <label :for="`pDni-${idx}`" class="mb-1">Nro. de documento</label>
                              <div>
                                <input
                                  v-model="item.document"
                                  :id="`pDni-${idx}`"
                                  class="form-control form-control-sm"
                                  type="tel"
                                  :placeholder="item.documentType"
                                  :minlength="item.documentType === 'DNI' ? 8 : 6"
                                  :maxlength="item.documentType === 'DNI' ? 8 : 15"
                                  pattern="[a-zA-Z0-9]+"
                                  required
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="form-group">
                              <label :for="`pNames-${idx}`" class="mb-1">Nombres</label>
                              <div>
                                <input
                                  v-model.trim="item.name"
                                  :id="`pNames-${idx}`"
                                  class="form-control form-control-sm"
                                  type="text"
                                  placeholder=""
                                  required
                                  @input="forceUpper($event, item, 'name')"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="form-group">
                              <label :for="`pApepat-${idx}`" class="mb-1">Apellidos</label>
                              <div>
                                <input
                                  v-model.trim="item.lastName"
                                  :id="`pApepat-${idx}`"
                                  class="form-control form-control-sm"
                                  type="text"
                                  placeholder=""
                                  required
                                  @input="forceUpper($event, item, 'lastName')"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <div class="form-group">
                              <label :for="`pPhone-${idx}`" class="mb-1">N° Teléfono/Celular</label>
                              <input
                                v-model="item.phone"
                                :id="`pPhone-${idx}`"
                                type="number"
                                class="form-control"
                                placeholder="Teléfono"
                                minlength="6"
                                maxlength="15"
                                required
                              />
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group">
                              <label class="mb-1">Fecha de nacimiento</label>
                              <v-date-picker
                                v-model="item.temp_fn"
                                :max-date="toDateStart"
                                :masks="{ weekdays: 'WWW' }"
                                @input="changeDate($event, item)"
                              >
                                <template v-slot="{ inputValue, inputEvents }">
                                  <input
                                    class="form-control form-control-sm"
                                    :value="inputValue"
                                    v-on="inputEvents"
                                    placeholder="1990-10-01"
                                    required
                                  />
                                </template>
                              </v-date-picker>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="form-group">
                              <label :for="`pSexo-${idx}`" class="mb-1">Sexo</label>
                              <div>
                                <select
                                  v-model="item.gender"
                                  :id="`pSexo-${idx}`"
                                  class="form-control form-control-sm"
                                  required
                                >
                                  <option value="">Seleccionar</option>
                                  <option value="M">Masculino</option>
                                  <option value="F">Femenino</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mt-2">
                          <h6 class="text-action">
                            <b>Selecciona el tipo de prueba</b>
                          </h6>
                          <div v-if="lTickets">
                            <i class="fa fa-spin fa-spinner"></i>
                          </div>
                          <div v-else class="row">
                            <div class="col-12">
                              <div class="form-group">
                                <label :for="`pType-${idx}`" class="mb-1">Tipo de prueba</label>
                                <div>
                                  <select
                                    v-model="item.typeId"
                                    :id="`pType-${idx}`"
                                    class="form-control form-control-sm"
                                    required
                                  >
                                    <option value="">Seleccionar</option>
                                    <option
                                      v-for="t in typesData"
                                      :key="t.ticketTypeId"
                                      :value="t.ticketTypeId"
                                    >
                                      {{ `${t.name} - S/ ${t.price}` }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <h6 class="text-action">
                          <b>Ingrese la dirección</b>
                        </h6>
                        <div v-if="item.eAddress" class="text-danger mb-2">
                          {{ item.eAddress }}
                        </div>
                        <div v-if="idx > 0" class="form-group">
                          <label for="ma-department" class="mb-1">
                            Usar una dirección anterior
                          </label>
                          <select
                            v-model="item.addressId"
                            @change="onSelectPrevAddress(item)"
                            id="ma-department"
                            class="form-control form-control-sm"
                            :required="item.hasPrevAddress"
                          >
                            <option value="">Seleccionar</option>
                            <option
                              v-for="i in participantsNewAddress"
                              :key="i.addressId"
                              :value="i.addressId"
                            >
                              {{ `Usar dirección de ${i.name} ${i.lastName}` }}
                            </option>
                          </select>
                        </div>
                        <div v-if="!item.hasPrevAddress">
                          <FormAddress v-model="item.formAddress" :activityId="activityId" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="canNewParticipant"
                  class="card bg-light c-pointer"
                  @click="addParticipant()"
                >
                  <div class="py-2 px-3">
                    <div v-if="error" class="text-danger mb-1">
                      <b>{{ error }}</b>
                    </div>
                    ¿Quiéres agregar un paciente más?
                    <b class="text-action">
                      Agregar
                      <i class="fa fa-plus-circle"></i>
                    </b>
                    <i v-if="lAddress && !patientsSubmit" class="fa fa-spin fa-spinner ml-2"></i>
                  </div>
                </div>
              </div>
              <div class="text-right">
                <button
                  type="submit"
                  class="btn btn-warning rounded-50"
                  :disabled="lAddress && patientsSubmit"
                >
                  <i v-if="lAddress && patientsSubmit" class="fa fa-spin fa-spinner mr-2"></i>
                  Guardar y continuar
                </button>
              </div>
            </form>
          </div>
        </div>
        <div v-if="isStep(5)" class="col-md-9 col-lg-7">
          <div class="card bg-light">
            <form class="p-3 p-sm-4" @submit.prevent="step = 6">
              <h5 class="mb-3">
                <a href="#" class="text-decoration-none" @click.prevent="step = 4">
                  <i class="fa fa-arrow-left"></i>
                </a>
                <span class="stepper__count ml-3 mr-1 small">
                  <b>5</b>
                </span>
                Ingresa los datos de facturación
              </h5>
              <div class="my-4">
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label class="mb-1">Tipo de comprobante</label>
                      <div>
                        <select
                          v-model="invoice.tipo_comprobante"
                          class="form-control form-control-sm"
                          required
                        >
                          <option value="">Seleccionar</option>
                          <option :value="1">Factura</option>
                          <option :value="3">Boleta</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label class="mb-1">Tipo de persona</label>
                      <div>
                        <select
                          v-model="invoice.tipo_persona"
                          class="form-control form-control-sm"
                          required
                        >
                          <option value="">Seleccionar</option>
                          <option v-if="invoice.tipo_comprobante !== 1" :value="115">
                            Persona natural
                          </option>
                          <option v-if="invoice.tipo_comprobante === 1" :value="116">
                            Persona jurídica
                          </option>
                          <option v-if="invoice.tipo_comprobante !== 1" :value="117">
                            Sujeto no domiciliado
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div v-if="invoice.tipo_comprobante === 3" class="col-12">
                    <div class="form-group">
                      <b-form-checkbox v-model="autoCompleteF" switch>
                        Usar datos del comprador
                      </b-form-checkbox>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label class="mb-1">Tipo documento</label>
                      <div>
                        <select
                          v-model="invoice.tipo_documento"
                          class="form-control form-control-sm"
                          required
                        >
                          <option value="">Seleccionar</option>
                          <option v-if="invoice.tipo_persona !== 116" :value="1">DNI</option>
                          <option v-if="invoice.tipo_persona === 116" :value="6">RUC</option>
                          <option v-if="invoice.tipo_persona !== 116" :value="4">
                            Carnet extranjería
                          </option>
                          <option v-if="invoice.tipo_persona !== 116" :value="7">Pasaporte</option>
                          <option v-if="invoice.tipo_persona !== 116" :value="5">Otros</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="invoice.tipo_persona !== 116 && invoice.tipo_comprobante !== 1"
                    class="col-6"
                  >
                    <div class="form-group">
                      <label class="mb-1">Nro. de documento</label>
                      <div>
                        <input
                          v-model="invoice.id_cliente"
                          class="form-control form-control-sm"
                          type="tel"
                          placeholder=""
                          required
                          :minlength="invoice.tipo_documento === 1 ? 8 : 6"
                          :maxlength="invoice.tipo_documento === 1 ? 8 : 15"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-if="requireRuc" class="col-6">
                    <div class="form-group">
                      <label class="mb-1">RUC</label>
                      <div>
                        <input
                          v-model="invoice.ruc"
                          class="form-control form-control-sm"
                          type="tel"
                          placeholder=""
                          minlength="11"
                          maxlength="11"
                          pattern="\d*"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div v-if="requireRuc" :class="invoice.tipo_persona === 116 ? 'col-12' : 'col-6'">
                    <div class="form-group">
                      <label class="mb-1">Razón social | Nombre</label>
                      <div>
                        <input
                          v-model.trim="invoice.nombre_cliente"
                          class="form-control form-control-sm"
                          type="text"
                          placeholder=""
                          required
                          @input="forceUpper($event, invoice, 'nombre_cliente')"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-if="invoice.tipo_comprobante === 3" class="col-6">
                    <div class="form-group">
                      <label class="mb-1">Primer nombre</label>
                      <div>
                        <input
                          v-model.trim="invoice.primer_nombre"
                          class="form-control form-control-sm"
                          type="text"
                          placeholder=""
                          required
                          @input="forceUpper($event, invoice, 'primer_nombre')"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-if="invoice.tipo_comprobante === 3" class="col-6">
                    <div class="form-group">
                      <label class="mb-1">Segundo nombre</label>
                      <div>
                        <input
                          v-model.trim="invoice.segundo_nombre"
                          class="form-control form-control-sm"
                          type="text"
                          placeholder=""
                          @input="forceUpper($event, invoice, 'segundo_nombre')"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-if="invoice.tipo_comprobante === 3" class="col-6">
                    <div class="form-group">
                      <label class="mb-1">Primer apellido</label>
                      <div>
                        <input
                          v-model.trim="invoice.primer_apellido"
                          class="form-control form-control-sm"
                          type="text"
                          placeholder=""
                          required
                          @input="forceUpper($event, invoice, 'primer_apellido')"
                        />
                      </div>
                    </div>
                  </div>
                  <div v-if="invoice.tipo_comprobante === 3" class="col-6">
                    <div class="form-group">
                      <label class="mb-1">Segundo apellido</label>
                      <div>
                        <input
                          v-model.trim="invoice.segundo_apellido"
                          class="form-control form-control-sm"
                          type="text"
                          placeholder=""
                          @input="forceUpper($event, invoice, 'segundo_apellido')"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label class="mb-1">Correo electrónico</label>
                      <div>
                        <input
                          v-model.trim="invoice.email"
                          class="form-control form-control-sm"
                          type="email"
                          placeholder="Correo electrónico"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="form-group">
                      <label class="mb-1">Dirección</label>
                      <div>
                        <input
                          v-model="invoice.direccion"
                          class="form-control form-control-sm"
                          type="text"
                          placeholder=""
                          required
                          @input="forceUpper($event, invoice, 'direccion')"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="text-right">
                <button type="submit" class="btn btn-warning rounded-50" :disabled="loading">
                  <i v-if="loading" class="fa fa-spin fa-spinner mr-2"></i>
                  Guardar y continuar
                </button>
              </div>
            </form>
          </div>
        </div>
        <div v-if="isStep(6)" class="col-md-8 col-lg-6">
          <div class="card bg-light">
            <div class="p-3 p-sm-4">
              <h5 class="mb-3">
                <a href="#" class="text-decoration-none mr-2" @click.prevent="step = 5">
                  <i class="fa fa-arrow-left"></i>
                </a>
                Generar reserva
              </h5>
              <div v-if="dateSelect" class="my-4">
                <div class="mb-2">
                  <b>{{ eventData.title }}</b>
                </div>
                <div class="mb-2">
                  <span>{{ dateSelect.dateFriendly }}</span>
                </div>
                <div class="mb-3">
                  <span>
                    {{ twoSchedules ? 'Horario: ' : 'Hora: ' }}
                    {{
                      twoSchedules
                        ? getSchedule(dateHourSelect)
                        : parseHourString(dateHourSelect.timeStart)
                    }}
                  </span>
                </div>
                <div>
                  <div class="card p-3 mb-3">
                    <h6>
                      <b>Datos de comprador</b>
                    </h6>
                    <div>
                      {{ `${user.name} ${user.lastName}` }} <br />
                      {{ user.email }} <br />
                      {{ user.phone }}
                    </div>
                  </div>
                  <div v-for="(p, idx) in participants" :key="idx" class="card px-3 py-2 mb-2">
                    <h6 class="mb-2">
                      {{ `${p.name} ${p.lastName} - ${p.document}` }}
                    </h6>
                    <div class="mb-1 row">
                      <div class="col">
                        {{ getTicketParticipant(p).name }}
                      </div>
                      <div class="col-auto">
                        {{ currencySymbol }} {{ getTicketParticipant(p).price }}
                      </div>
                    </div>
                    <div class="mb-1 row">
                      <div class="col">Delivery</div>
                      <div class="col-auto">
                        {{ currencySymbol }}
                        {{
                          p.hasPrevAddress || deliveryFree
                            ? '0'
                            : p.formAddress.deliveryZone.deliveryFee
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card px-3 py-2 mb-3">
                  <div class="row">
                    <b class="col">Subtotal: </b>
                    <b class="col-auto"> {{ currencySymbol }} {{ total.subtotal.toFixed(2) }} </b>
                  </div>
                  <div class="row">
                    <b class="col">Descuentos: </b>
                    <b class="col-auto"> {{ currencySymbol }} {{ total.discount.toFixed(2) }} </b>
                  </div>
                  <div class="row">
                    <b class="col">Total a pagar: </b>
                    <b class="col-auto text-action">
                      {{ currencySymbol }} {{ total.pay.toFixed(2) }}
                    </b>
                  </div>
                </div>
                <form @submit.prevent="verifyCoupon()" class="card p-3 mb-3">
                  <h6>
                    <b>¿Tienes un código de descuento?</b>
                  </h6>
                  <div v-if="couponOk" class="text-success">
                    Cupón aplicado correctamente.
                    <a href="#" @click.prevent="removeCoupon()" class="text-danger">Eliminar</a>
                  </div>
                  <div v-else class="input-group">
                    <input
                      v-model="couponCode"
                      type="text"
                      class="form-control"
                      placeholder="Ingresa el código aquí"
                    />
                    <div class="input-group-append">
                      <button class="btn btn-outline-secondary" type="submit">Validar</button>
                    </div>
                  </div>
                </form>
              </div>
              <div v-if="error || errorDelivery" class="text-danger small mb-3">
                {{ error || errorDelivery }}
              </div>
              <div class="text-right">
                <button
                  type="button"
                  class="btn btn-warning rounded-50"
                  :disabled="loading"
                  @click="buyTickets()"
                >
                  <i v-if="loading" class="fa fa-spin fa-spinner mr-2"></i>
                  Confirmar reserva
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isStep(7)" class="col-md-8 col-lg-6">
          <div class="card bg-light text-center">
            <div class="p-3 p-sm-4">
              <h6 class="mb-3">#UNILABS: Servicio a Domicilio</h6>
              <div class="my-4">
                <div class="card bg-light p-3">
                  <h6 class="mb-2">Reserva generada correctamente</h6>
                  <div class="mb-3">Estará disponible para pagar por 15 minutos</div>
                  <div class="mb-3">
                    <a :href="linkPay" target="_blank" class="btn btn-warning rounded-50">
                      Ver link de pago
                    </a>
                  </div>
                  <div v-if="loadingLink">
                    <i class="fa fa-spin fa-spinner fa-2x"></i>
                    <br />
                    Enviando link de pago
                  </div>
                  <div v-else>
                    <div v-if="error">Error al enviar el link de pago.</div>
                    <div v-else>
                      Se ha enviado un correo con el link de pago a:
                      <br />
                      <b class="text-action">
                        {{ user.email || 'Error' }}
                      </b>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="!loadingLink" class="card p-3 p-md-4 mb-3">
                <h6 class="mb-3 mt-2">
                  <b>COMPARTIR:</b>
                </h6>
                <div class="form-row">
                  <div class="col-lg-6 mb-3">
                    <a :href="shareWp" target="_blank" class="btn btn-warning btn-block rounded-50">
                      Enviar vía whatsapp
                    </a>
                  </div>
                  <div class="col-lg-6 mb-3">
                    <button
                      type="button"
                      class="btn btn-outline-warning btn-block rounded-50"
                      @click.prevent="modalResend = true"
                    >
                      Reenviar link de pago
                    </button>
                  </div>
                </div>
              </div>
              <div class="text-center">
                <button type="button" class="btn btn-outline-dark rounded-50" @click="newShop()">
                  Generar nueva venta
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      v-model="modalResend"
      title="Reenviar link de pago"
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
    >
      <form @submit.prevent="sendLink()" class="p-3">
        <div class="form-group">
          <label for="nemail" class="mb-1">Nuevo Correo electrónico</label>
          <input
            v-model="newEmail"
            id="nemail"
            type="email"
            class="form-control"
            placeholder=""
            required
          />
        </div>
        <div v-if="resendLink" class="text-center text-success mt-3">Correo enviado con éxito.</div>
        <div v-if="error" class="text-center text-danger mt-3">
          {{ error }}
        </div>
        <div class="text-center mt-4">
          <button type="submit" class="btn btn-warning px-5" :disabled="loadingLink">
            <i v-if="loadingLink" class="fa fa-spin fa-spinner mr-2"></i>
            Enviar
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
import jwt from 'jsonwebtoken';
import api from '../api';

const docTypes = ['DNI', 'RUC', 'PASS', 'CE', 'OTRO'];

const participant = {
  name: '', // ok
  lastName: '', // ok
  documentType: 'DNI', // ok
  document: '', // ok
  birthdate: '', // ok
  gender: '', // ok
  email: '', // ok-n
  phone: '', // ok
  address: '', // ok
  district: '', // ok
  reference: '', // ok
  externalOrigin: 'AUTOCV_001',
  // new
  typeId: '',
  addressId: '',
  formAddress: {},
  dataDelivery: {}
};

const paciente = {
  fecha_programacion: '',
  dni: '',
  nombres: '',
  ape_pat: '',
  ape_mat: '',
  fecha_nac: '',
  sexo: '',
  origen_externo: 'AUTOCV_001',
  telefono: '',
  email: '',
  password: null,
  address: '',
  reference: '',
  distrito: ''
};

const groupBy = (xs, key) =>
  xs.reduce((rv, x) => {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});

const getDiscount = (subTotal, coupon) => {
  if (coupon.type === 1) return (subTotal * coupon.discountValue) / 100;
  return coupon.discountValue;
};

export default {
  data() {
    return {
      docTypes,
      step: 0,
      loading: false,
      lTickets: false,
      lAddress: false,
      loadingLink: false,
      activityId: this.$route.params.eventId,
      isHeadquarters: false,
      selectedDate: null,
      error: '',
      errorDelivery: '',
      // data gets
      eventData: {},
      datesData: [],
      typesData: [],
      // models
      dateSelect: null,
      dateHourSelect: null,
      user: {
        name: '',
        lastName: '',
        email: '',
        documentType: 'DNI',
        document: '',
        reemail: '',
        phone: ''
      },
      participants: [],
      invoice: {
        origen_externo: 'AUTOCV_001',
        tipo_comprobante: '',
        tipo_persona: '',
        tipo_documento: '',
        id_cliente: '',
        ruc: '',
        nombre_cliente: '',
        primer_nombre: '',
        segundo_nombre: '',
        primer_apellido: '',
        segundo_apellido: '',
        email: '',
        direccion: '',
        total_con_igv: null,
        cantidad_detalle: null,
        nombre_completo_paciente: ''
      },
      autoCompleteP: false,
      patientsSubmit: false,
      autoCompleteF: false,
      transaction: null,
      linkPay: '',
      modalResend: false,
      newEmail: '',
      resendLink: false,
      couponCode: '',
      couponData: {},
      couponOk: false,
      couponLoading: false,
      // fake
      paciente
    };
  },
  mounted() {
    this.participants.push(JSON.parse(JSON.stringify(participant)));
    this.getDataEvent();
  },
  computed: {
    availableDates() {
      let dates = [...this.datesData];
      const dt = new Date();
      const [now] = dt.toJSON().split('T');
      if (this.isHeadquarters) {
        dates = dates.filter((i) => i.dateKey === now);
      }
      return dates.map((i) => ({
        start: new Date(`${i.dateKey} 00:00:00`),
        end: new Date(`${i.dateKey} 23:59:59`)
      }));
    },
    attributes() {
      return [
        {
          highlight: {
            fillMode: 'light',
            color: 'red'
          },
          dates: this.datesData.map((i) => new Date(`${i.dateKey} 00:00:00`))
        }
      ];
    },
    twoSchedules() {
      const fd = this.getMetaValue(this.eventData.metadata, 'twoSchedules');
      return !!fd;
    },
    toDateStart() {
      const d = new Date();
      const day = 1000 * 60 * 60 * 24;
      d.setTime(d.getTime() - day * 2);
      return d;
    },
    canNewParticipant() {
      return this.dateHourSelect.qtyStock > this.participants.length;
    },
    participantsNewAddress() {
      return this.participants.filter((i) => !i.hasPrevAddress && i.addressId);
    },
    requireRuc() {
      return this.invoice.tipo_comprobante === 1 && this.invoice.tipo_persona === 116;
    },
    currencySymbol() {
      return this.eventData.currency === 'PEN' ? 'S/' : '$';
    },
    total() {
      if (!this.participants.length) return 0;
      const res = this.participants.map((i) => {
        const f = this.typesData.find((t) => t.ticketTypeId === parseInt(i.typeId, 10));
        const cp = this.couponOk
          ? this.couponData.data.find((t) => t.ticketTypeId === parseInt(i.typeId, 10))
          : null;
        const fPrice = parseFloat(f.price);
        let pay = cp ? fPrice - getDiscount(fPrice, cp) : fPrice;
        const discount = cp ? getDiscount(fPrice, cp) : 0;
        if (!i.hasPrevAddress && !this.deliveryFree) {
          pay += parseFloat(i.formAddress.deliveryZone.deliveryFee);
        }
        return {
          pay,
          discount
        };
      });
      const discount = res.map((i) => i.discount).reduce((a, b) => a + b);
      const pay = res.map((i) => i.pay).reduce((a, b) => a + b);
      return {
        subtotal: pay + discount,
        discount,
        pay
      };
    },
    deliveryFree() {
      return this.couponOk ? this.couponData.data[0].deliveryFree : 0;
    },
    shareWp() {
      const wp = 'https://api.whatsapp.com/send';
      return `${wp}?phone=${this.user.phone}&text=Link de pago @joinnus: ${this.linkPay}`;
    }
  },
  watch: {
    autoCompleteP(val) {
      const [item] = this.participants;
      this.participants[0] = this.autoCompleteItem(item, val);
    },
    participants: {
      handler() {
        this.error = '';
      },
      deep: true
    },
    autoCompleteF(val) {
      if (val) {
        this.autoCompleteInvoice();
      } else {
        this.autoCompleteInvoice('clear');
      }
    }
  },
  methods: {
    isStep(step) {
      return this.step === step;
    },
    selectDate(day) {
      if (!day) {
        this.dateSelect = null;
        return;
      }
      const [id] = this.selectedDate.toISOString().split('T');
      this.paciente.fecha_programacion = id.replace(/-/g, '');
      this.dateSelect = this.datesData.find((i) => i.dateKey === id);
      const dt = new Date();
      const dmt = this.selectedDate.setDate(this.selectedDate.getDate() - 1);
      const dm = new Date(dmt);
      if (dm.getDate() > dt.getDate()) return;
      const ch = dt.getHours();
      const fh = this.dateSelect.hours.filter((i) => {
        if (ch >= 17) {
          return parseInt(i.timeStart.substring(0, 2), 0) >= 13;
        }
        return i;
      });
      this.dateSelect.hours = fh;
    },
    selectDateHour(hour) {
      this.dateHourSelect = hour;
    },
    async validateDataUser() {
      let validate = true;
      this.error = '';
      if (this.user.documentType === 'DNI') {
        validate = await this.validateUser({
          ...this.user,
          fullName: `${this.user.name} ${this.user.lastName}`
        });
      }
      if (!validate) return;
      this.step = 4;
      this.getDataTickets();
    },
    async addParticipant() {
      const itemPrev = this.participants[this.participants.length - 1];
      const vAddress = itemPrev.hasPrevAddress || this.validatePatient(itemPrev);
      if (!vAddress) {
        this.error = 'Completa todos los datos requeridos del paciente anterior.';
        return;
      }
      let sAddress = true;
      if (!itemPrev.addressId) {
        sAddress = await this.saveAddress(itemPrev);
      }
      if (!sAddress) {
        this.error = 'Error al guardar la dirección del paciente anterior.';
        return;
      }
      const arr = [];
      if (!itemPrev.document) arr.push('Nro. de documento');
      if (!itemPrev.name) arr.push('Nombres');
      if (!itemPrev.lastName) arr.push('Apellidos');
      if (!itemPrev.birthdate) arr.push('Fecha de nacimiento');
      if (!itemPrev.gender) arr.push('Sexo');
      if (!itemPrev.typeId) arr.push('Tipo de prueba');
      if (arr.length) {
        this.error = `Completa los datos del paciente anterior(${arr.join(', ')}).`;
        return;
      }
      if (this.patientsSubmit) {
        this.step = 5;
      } else {
        const p = { ...participant, phone: this.user.phone };
        this.participants.push(JSON.parse(JSON.stringify(p)));
      }
      this.patientsSubmit = false;
    },
    trashParticipant(idx) {
      this.participants.splice(idx, 1);
    },
    async saveAddress(item) {
      const { name: firstName, lastName, documentType, document, phone } = item;
      const payload = {
        ...item.formAddress,
        firstName,
        lastName,
        documentType,
        document,
        phone
      };
      this.lAddress = true;
      const { data } = await api.axios.post('/addresses', payload);
      this.lAddress = false;
      if (data.status) {
        item.addressId = data.data.id;
        item.dataDelivery = data.data;
        return true;
      }
      this.$set(item, 'eAddress', data.message);
      setTimeout(() => {
        item.eAddress = '';
      }, 7000);
      return false;
    },
    onSelectPrevAddress(item) {
      const val = !!item.addressId;
      this.$set(item, 'hasPrevAddress', val);
    },
    nextInvoice() {
      this.patientsSubmit = true;
      this.addParticipant();
    },
    async buyTickets() {
      this.error = '';
      const p1 = this.participants[0];
      this.invoice.nombre_completo_paciente = `${p1.name} ${p1.lastName}`;
      this.invoice.cantidad_detalle = this.participants.length;
      this.invoice.movilidad = 1;
      // ok
      const user = {
        ...this.user,
        user_id: '',
        session: '',
        iso: 'PE',
        origin: 'boxoffice-callcenter-lab',
        token: 'abc',
        unique: '-'
      };

      // fallback
      const [ap, am] = p1.lastName.split(' ');
      this.paciente.dni = p1.document;
      this.paciente.nombres = p1.name;
      this.paciente.ape_pat = ap;
      this.paciente.ape_mat = am;
      this.paciente.fecha_nac = p1.birthdate;
      this.paciente.sexo = p1.gender;
      // from user
      this.paciente.telefono = this.user.phone;
      this.paciente.email = this.user.email;
      // this.paciente.address = this.hasDelivery && this.dataDelivery.address; // ref
      this.paciente.address = p1.dataDelivery.address;
      this.paciente.reference = p1.dataDelivery.reference;
      this.paciente.distrito = p1.dataDelivery.ubigeo[0].isoCode;

      this.participants.map((p) => {
        this.$set(p, 'email', this.user.email);
        // this.$set(p, 'address', this.hasDelivery && this.dataDelivery.address); // ref
        const dd = this.getDataDelivery(p);
        this.$set(p, 'address', dd.address);
        this.$set(p, 'reference', dd.reference);
        this.$set(p, 'district', dd.ubigeo[0].isoCode);
        return p;
      });
      const tickets = [];
      const pGroup = groupBy(this.participants, 'typeId');
      Object.values(pGroup).forEach((arr) => {
        const p0 = arr[0];
        const fd = this.typesData.find((t) => t.ticketTypeId === parseInt(p0.typeId, 10));
        let coupon = '';
        if (this.couponOk) {
          const fdc = this.couponData.data.find((i) => i.ticketTypeId === p0.typeId);
          if (fdc) {
            coupon = fdc.code;
          }
        }
        const nItem = {
          event_id: this.activityId,
          activity_date_hour_id: this.dateHourSelect.timeId,
          ticket_type_id: p0.typeId,
          price: fd.price,
          ticketName: fd.name,
          quantity: arr.length,
          coupon,
          start_date: '',
          seats: [],
          billing: false,
          participant: false,
          participants: []
        };
        arr.forEach((p) => {
          const np = JSON.parse(JSON.stringify(p));
          delete np.formAddress;
          delete np.dataDelivery;
          nItem.participants.push(np);
        });
        tickets.push(nItem);
      });
      const payload = {
        user,
        type: {
          product: [],
          donacion: [],
          event: tickets
        },
        fovCode: '',
        timeExpiration: null,
        unilabs: {
          paciente: this.paciente,
          invoice: this.invoice,
          otrosPacientes: []
        },
        sellingUser: this.$store.state.auth.user.id
      };

      this.loading = true;

      const details = jwt.sign(payload, 'jnputin', { noTimestamp: true });
      const search = window.location.search.replace(/\?/g, '&');
      const res = await api.reservation(details, true, 'joinnus-callcenter-lab', search);

      this.loading = false;

      if (res.status) {
        this.linkPay = res.route;
        this.transaction = res.data;
        this.saveAddressTransaction();
        // if (this.hasDelivery) {
        //   this.saveAddressTransaction();
        // } else {
        //   this.step = 5;
        //   this.sendLink();
        // }
      } else {
        this.error = res.message;
        setTimeout(() => {
          this.error = '';
        }, 9000);
      }
    },
    async saveAddressTransaction() {
      this.loading = true;
      const pGroup = groupBy(this.participants, 'addressId');
      const addresses = Object.keys(pGroup);
      const payload = {
        // addressId: this.participants[0].addressId,
        ticketId: this.transaction.data,
        multiple: true,
        addresses,
        deliveryFree: this.deliveryFree
      };
      try {
        const url = `${api.checkoutUrl}/reservation/add-delivery`;
        const { data } = await api.axios.post(url, payload);
        const codeOk = ['delivery-added', 'error-transaction-delivery-added'];
        if (codeOk.includes(data.code)) {
          this.step = 7;
          this.sendLink();
        } else {
          this.setErrorDelivery(data.message);
        }
      } catch (err) {
        const { response: res } = err;
        const codeOk = ['error-transaction-delivery-added'];
        if (res.data && codeOk.includes(res.data.code) && !res.data.message.includes('addressId')) {
          this.step = 7;
          this.sendLink();
        } else {
          this.setErrorDelivery('Error al asignar el delivery');
        }
      }
      this.loading = false;
    },
    async sendLink() {
      this.error = '';
      this.resendLink = false;
      this.loadingLink = true;
      const sHour = this.parseHourString(this.dateHourSelect.timeStart);
      const eHour = this.parseHourString(this.dateHourSelect.timeEnd);
      // const pHour = this.hasDelivery ? `${sHour} - ${eHour}` : sHour;
      const pHour = `${sHour} - ${eHour}`;
      const { dateFriendly } = this.dateSelect;
      const payload = {
        type: 'PAYMENT_LINK',
        data: {
          link: this.linkPay,
          email: this.newEmail || this.user.email,
          name: `${this.user.name} ${this.user.lastName}`,
          title: this.eventData.title,
          date: `${dateFriendly} | ${pHour}`,
          bannerUrl: this.eventData.image,
          files: this.files
        }
      };
      try {
        const res = await api.sendLinkEmail(payload);
        if (!res.success) {
          this.error = res.message;
        } else {
          this.resendLink = true;
          setTimeout(() => {
            this.resendLink = false;
            this.modalResend = false;
          }, 7000);
        }
      } catch (err) {
        this.error = 'Error 500';
      }
      this.loadingLink = false;
    },
    newShop() {
      window.location.reload();
    },
    // helpers
    getSchedule({ timeStart, timeEnd }) {
      const str = parseInt(timeEnd.substr(0, 2), 10) <= 13 ? 'Mañana' : 'Tarde';
      return `${str}: ${this.parseHourString(timeStart)} - ${this.parseHourString(timeEnd)}`;
    },
    forceUpper(e, o, prop) {
      const start = e.target.selectionStart;
      e.target.value = e.target.value.toUpperCase();
      this.$set(o, prop, e.target.value);
      e.target.setSelectionRange(start, start);
    },
    changeDate(day, vm) {
      const [id] = day.toISOString().split('T');
      vm.birthdate = id.replace(/-/g, '');
    },
    getTicketParticipant(p) {
      return this.typesData.find((i) => i.ticketTypeId === parseInt(p.typeId, 10));
    },
    getDataDelivery(p) {
      if (p.hasPrevAddress) {
        return this.participants.find((i) => i.addressId === p.addressId).dataDelivery;
      }
      return p.dataDelivery;
    },
    setErrorDelivery(msg) {
      this.errorDelivery = msg;
      setTimeout(() => {
        this.errorDelivery = '';
      }, 9000);
    },
    // others helpers
    async validateUser(user) {
      this.loading = true;
      try {
        const url = `${process.env.VUE_APP_API_PLATFORM}/endpoints/validate-documents`;
        const { data: res } = await api.axios.post(url, [user]);
        this.loading = false;
        if (!res.data[0].status) {
          this.error = res.data[0].message;
          return false;
        }
        return true;
      } catch (err) {
        this.error = 'Inténtalo en un momento.';
        this.loading = false;
        setTimeout(() => {
          this.error = '';
        }, 9000);
        return false;
      }
    },
    autoCompleteItem(item, isUser) {
      if (!isUser) {
        item = { ...item, ...JSON.parse(JSON.stringify(participant)) };
        this.$set(item, 'auto', false);
      } else {
        const user = { ...this.user };
        item.name = user.name.toUpperCase();
        item.lastName = user.lastName.toUpperCase();
        item.documentType = user.documentType;
        item.document = user.document;
        item.phone = user.phone;
        // item.email = user.email;
        this.$set(item, 'auto', true);
      }
      return item;
    },
    validatePatient(item) {
      const {
        name,
        lastName,
        documentType,
        document,
        phone,
        formAddress: { departmentU, address, lot, province, reference, ubigeoId, zoneId }
      } = item;
      const vDoc = documentType === 'DNI' ? document.length === 8 : document.length > 5;
      const vUser = name.length > 1 && lastName.length > 1 && phone.length >= 7 && vDoc;
      return vUser && departmentU && address && lot && province && reference && ubigeoId && zoneId;
    },
    autoCompleteInvoice(clear) {
      if (clear === 'clear') {
        this.invoice.tipo_documento = '';
        this.invoice.id_cliente = '';
        this.invoice.email = '';
        this.invoice.telefono = '';
        this.invoice.primer_nombre = '';
        this.invoice.segundo_nombre = '';
        this.invoice.primer_apellido = '';
        this.invoice.segundo_apellido = '';
      } else {
        const user = { ...this.user };
        const [n1, n2] = user.name.split(' ');
        const [a1, a2] = user.lastName.split(' ');

        this.invoice.tipo_documento = user.documentType === 'DNI' ? 1 : '';
        this.invoice.id_cliente = user.document;
        this.invoice.email = user.email;
        this.invoice.telefono = user.phone;
        this.invoice.primer_nombre = n1.toUpperCase();
        this.invoice.segundo_nombre = n2 ? n2.toUpperCase() : '';
        this.invoice.primer_apellido = a1.toUpperCase();
        this.invoice.segundo_apellido = a2 ? a2.toUpperCase() : '';
      }
    },
    // api gets
    async getDataEvent() {
      this.loading = true;
      const res = await api.getDataEvent(this.activityId);
      if (res) {
        this.eventData = res.eventData;
      }
      const dates = await api.getEventDates(this.activityId);
      const result = Object.keys(dates)
        .map((key) => {
          const dts = `${key} ${dates[key].hours[0].timeStart}`;
          return {
            id: dates[key].id,
            dateKey: key,
            start: new Date(dts.replace(/-/g, '/')),
            dateFriendly: dates[key].dateFriendly,
            hours: dates[key].hours
          };
        })
        .filter((el) => {
          const today = new Date();
          // const yesterday = today.setDate(today.getDate() - 1);
          return el.start > today;
        });

      this.datesData = result;
      this.loading = false;
      this.step = 1;
    },
    async getDataTickets() {
      this.lTickets = true;
      const types = await api.getEventTypes(
        this.activityId,
        this.dateHourSelect.timeId,
        '&origin=offline'
      );
      const typesDataFilter = types.filter((i) => !i.isFov);
      this.typesData = typesDataFilter.map((el) => {
        this.$set(el, 'quantity', 1);
        return el;
      });
      this.lTickets = false;
    },
    async verifyCoupon() {
      if (!this.couponCode) return;
      const payload = {
        dateHourId: this.dateHourSelect.timeId,
        text: this.couponCode
      };
      this.couponLoading = true;
      const res = await api.verifyCouponByEvent(this.activityId, payload);
      this.couponLoading = false;
      if (!res.status) {
        this.error = res.message;
        this.couponOk = false;
        setTimeout(() => {
          this.error = '';
        }, 7000);
      } else {
        this.couponOk = true;
        this.couponData = res;
      }
    },
    removeCoupon() {
      this.couponCode = '';
      this.couponOk = false;
      this.couponData = {};
    }
  }
};
</script>

<style>
.vc-container {
  border: 1px transparent !important;
}
</style>
